package com.castly.admin.ui

/**
 * Strips HTML tags from a string and decodes common HTML entities.
 * Useful for displaying HTML content as plain text.
 */
fun stripHtmlTags(html: String): String {
    return html
        .replace(Regex("<[^>]+>"), "") // Remove all HTML tags
        .replace(Regex("&nbsp;"), " ") // Replace &nbsp; with space
        .replace(Regex("&amp;"), "&") // Replace &amp; with &
        .replace(Regex("&lt;"), "<") // Replace &lt; with <
        .replace(Regex("&gt;"), ">") // Replace &gt; with >
        .replace(Regex("&quot;"), "\"") // Replace &quot; with "
        .replace(Regex("&#39;"), "'") // Replace &#39; with '
        .replace(Regex("&#x27;"), "'") // Replace &#x27; with '
        .replace(Regex("&#x2F;"), "/") // Replace &#x2F; with /
        .trim()
}